import { LocalizedProcessingBadge } from '@/shared/ui/LocalizedProcessingBadge'

interface ToolHeadingProps {
  title: string
  description: string
}

export function ToolHeading({ title, description }: ToolHeadingProps) {
  return (
    <div className="max-w-3xl">
      <div className="mb-2 sm:mb-3">
        <LocalizedProcessingBadge variant="local" />
      </div>
      <h1 className="text-2xl font-bold tracking-normal sm:text-4xl">{title}</h1>
      <p className="mt-2 line-clamp-2 text-sm leading-6 text-muted-foreground sm:line-clamp-none sm:text-base sm:leading-7">
        {description}
      </p>
    </div>
  )
}
